import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import Icon, { IconType } from '../../../icons/Icon';
import { Button, ButtonVariant } from '../Button';

interface AddButtonProps extends ButtonTemplateProps {}

export default function AddButton(props: AddButtonProps) {
  return (
    <Button
      {...props}
      text={props.text || t(TranslationKey.add).singular.upper}
      leading={<Icon type={IconType.plus} size={'h-5 w-5'} />}
      variant={ButtonVariant.primary}
    />
  );
}
